import { lazy } from 'react';

export const RenotifySpotlight = lazy(
	() =>
		// eslint-disable-next-line import/dynamic-import-chunkname
		import(/* webpackChunkName: "async-people-menu-renotify-spotlight" */ './RenotifySpotlight'),
);
